import { call, put, takeLatest, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  fetchPicklesRequest,
  fetchPicklesSuccess,
  fetchPicklesFailure,
  createPickleRequest,
  createPickleSuccess,
  createPickleFailure,
  updatePickleRequest,
  updatePickleSuccess,
  updatePickleFailure,
  deletePickleRequest,
  deletePickleSuccess,
  deletePickleFailure,
} from '../slices/pickleSlice';
import { showLoading, hideLoading } from '../slices/loadingSlice'; // ✅ ADD THIS

const getRole = (state) => state.auth.user?.role;
const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL;
function* fetchPicklesSaga() {
  try {
    yield put(showLoading('Loading pickles...')); // ✅ ADD THIS
    
    const role = yield select(getRole);
    const endpoint = role === 'ADMIN' 
      ? `${API_BASE_URL}/api/admin/pickles`
      : `${API_BASE_URL}/api/customer/pickles`;
    
    const response = yield call(axios.get, endpoint);
    yield put(fetchPicklesSuccess(response.data));
  } catch (error) {
    yield put(fetchPicklesFailure(error.response?.data?.message || 'Failed to fetch pickles'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

function* createPickleSaga(action) {
  try {
    yield put(showLoading('Creating pickle...')); // ✅ ADD THIS
    
    const response = yield call(
      axios.post,
      `${API_BASE_URL}/api/admin/pickles`,
      action.payload
    );
    yield put(createPickleSuccess(response.data));
  } catch (error) {
    yield put(createPickleFailure(error.response?.data?.message || 'Failed to create pickle'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

function* updatePickleSaga(action) {
  try {
    yield put(showLoading('Updating pickle...')); // ✅ ADD THIS
    
    const { id, data } = action.payload;
    const response = yield call(
      axios.put,
      `${API_BASE_URL}/api/admin/pickles/${id}`,
      data
    );
    yield put(updatePickleSuccess(response.data));
  } catch (error) {
    yield put(updatePickleFailure(error.response?.data?.message || 'Failed to update pickle'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

function* deletePickleSaga(action) {
  try {
    yield put(showLoading('Deleting pickle...')); // ✅ ADD THIS
    
    yield call(axios.delete, `${API_BASE_URL}/api/admin/pickles/${action.payload}`);
    yield put(deletePickleSuccess(action.payload));
  } catch (error) {
    yield put(deletePickleFailure(error.response?.data?.message || 'Failed to delete pickle'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

export default function* pickleSaga() {
  yield takeLatest(fetchPicklesRequest.type, fetchPicklesSaga);
  yield takeLatest(createPickleRequest.type, createPickleSaga);
  yield takeLatest(updatePickleRequest.type, updatePickleSaga);
  yield takeLatest(deletePickleRequest.type, deletePickleSaga);
}
